import React, { useState } from "react";
import "./LoginForm.css";

const Icon = ({ children }) => (
  <svg
    className="lf-field__icon"
    viewBox="0 0 24 24"
    width="20"
    height="20"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.7"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    {children}
  </svg>
);

const MailIcon = () => (
  <Icon>
    <rect x="3" y="5" width="18" height="14" rx="2.5" />
    <path d="M3.5 7.5l8.5 6 8.5-6" />
  </Icon>
);

const LockIcon = () => (
  <Icon>
    <rect x="4.5" y="10.5" width="15" height="10" rx="2.5" />
    <path d="M8 10.5V7.5a4 4 0 018 0v3" />
  </Icon>
);

const EyeIcon = ({ off }) => (
  <svg
    viewBox="0 0 24 24"
    width="20"
    height="20"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.7"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M2 12s3.6-6.5 10-6.5S22 12 22 12s-3.6 6.5-10 6.5S2 12 2 12z" />
    <circle cx="12" cy="12" r="3" />
    {off && <path d="M4 4l16 16" />}
  </svg>
);

const LoginForm = ({ onSubmit, loading = false, error = "" }) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (loading) return;
    const fd = new FormData(e.currentTarget);
    onSubmit?.({
      email: String(fd.get("email") || "").trim(),
      password: String(fd.get("password") || ""),
      remember: fd.get("remember") === "on",
    });
  };

  return (
    <form className="lf" onSubmit={handleSubmit} noValidate aria-busy={loading}>
      <div className="lf-group">
        <label className="lf-label" htmlFor="login-email">
          Adresse e-mail
        </label>
        <div className="lf-field">
          <MailIcon />
          <input
            id="login-email"
            name="email"
            type="email"
            autoComplete="email"
            placeholder="nom@organisation.fr"
            disabled={loading}
            aria-invalid={Boolean(error)}
            aria-describedby={error ? "login-error" : undefined}
          />
        </div>
      </div>

      <div className="lf-group">
        <label className="lf-label" htmlFor="login-password">
          Mot de passe
        </label>
        <div className="lf-field">
          <LockIcon />
          <input
            id="login-password"
            name="password"
            type={showPassword ? "text" : "password"}
            autoComplete="current-password"
            placeholder="Votre mot de passe"
            disabled={loading}
            aria-invalid={Boolean(error)}
            aria-describedby={error ? "login-error" : undefined}
          />
          <button
            type="button"
            className="lf-field__toggle"
            onClick={() => setShowPassword((v) => !v)}
            aria-label={
              showPassword ? "Masquer le mot de passe" : "Afficher le mot de passe"
            }
            aria-pressed={showPassword}
          >
            <EyeIcon off={showPassword} />
          </button>
        </div>
      </div>

      {error && (
        <p id="login-error" className="lf-error" role="alert">
          {error}
        </p>
      )}

      <div className="lf-row">
        <label className="lf-check">
          <input type="checkbox" name="remember" disabled={loading} />
          <span className="lf-check__box" aria-hidden="true">
            <svg viewBox="0 0 12 12" width="12" height="12">
              <path
                d="M2.5 6.5l2.2 2.2 4.8-5"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
          Rester connecté
        </label>

        <a className="lf-link" href="#forgot">
          Mot de passe oublié ?
        </a>
      </div>

      <button type="submit" className="lf-submit" disabled={loading}>
        {loading ? "Connexion…" : "Se connecter"}
      </button>
    </form>
  );
};

export default LoginForm;